import { SchadenbeteiligterKontakt } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export enum KontaktFormType {
  Verursacher = 'VERURSACHER',
  GeraeteStandort = 'GERAETE_STANDORT',
}

export const TYPE_SCHADENBETEILIGTER_KONTAKT_ERFASSEN = 'SCHADENBETEILIGTER_KONTAKT_ERFASSEN';

export interface SchadenbeteiligterKontaktErfassenModelConfig extends DynamicFormValueControlModelConfig<SchadenbeteiligterKontakt> {
  kontaktList?: SchadenbeteiligterKontakt[];
  kontaktFormType?: KontaktFormType;
}

export class SchadenbeteiligterKontaktErfassenModel extends DynamicFormValueControlModel<SchadenbeteiligterKontakt> {
  @serializable() readonly type: string = TYPE_SCHADENBETEILIGTER_KONTAKT_ERFASSEN;
  @serializable() kontaktList: SchadenbeteiligterKontakt[];
  @serializable() kontaktFormType: KontaktFormType;

  constructor(config: SchadenbeteiligterKontaktErfassenModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.kontaktList = config.kontaktList || [];
    this.kontaktFormType = config.kontaktFormType;
  }
}
